<template>
    <div>
        <breadcrumbs />
        <div class="mt-4">
            <client-only>
                <payments-page-schedule
                    :_is-manual-invoices-loading="isManualInvoicesLoading"
                    @change-is-manual-invoices-loading="isManualInvoicesLoading = $event"
                />
            </client-only>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import PaymentsPageSchedule from '@/components/account/PaymentsPageSchedule.vue'

    @Component({
        components: {
            PaymentsPageSchedule,
            Breadcrumbs,
        },
    })
    export class PaymentsPage extends Vue {
        isManualInvoicesLoading = false
    }

    export default PaymentsPage
</script>
